import { initializeRouter, registerRoute, RouterOptions } from 'owa-router';

export default async function initializeRouting(
    registerRoutes: (registerRouteFunction: typeof registerRoute) => Promise<void>,
    routerOptions: RouterOptions
) {
    if (registerRoutes) {
        await registerRoutes(registerRoute);
    }

    // Initialize the router AFTER registering routes so that the initial route will be executed
    initializeRouter(routerOptions);
}
